import { EmployeeDetails } from "../../../Types/UserProfileDetails";
import { IUser } from "../../login/types";

export const canViewEmployeeAttendance = (
  employee: EmployeeDetails | null | undefined,
  viewer: IUser | null | undefined,
): boolean => {
  if (!viewer) return false;
  const role = viewer.user_type?.trim().toLowerCase().replace(/[\s_]+/g, "");
  if (["admin", "hr"].includes(role)) return true;
  if (role !== "manager" || !viewer.id) return false;

  const job = employee?.jobInformation;
  return [job?.managerId, job?.additionalManagerIds].some((ids) =>
    ids?.split(",").some((id) => id.trim() === String(viewer.id)),
  );
};
